import { Card } from "@/shared/components/ui/card"
import { Button } from "@/shared/components/ui/button"
import { ShoppingCart } from "lucide-react"

export function CarritoPage() {
  return (
    <div className="pt-32 pb-20 lg:pt-40 lg:pb-32">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="text-center max-w-3xl mx-auto">
          <Card className="p-12 lg:p-20 space-y-6">
            <div className="w-20 h-20 rounded-full bg-muted mx-auto flex items-center justify-center">
              <ShoppingCart className="w-10 h-10 text-muted-foreground" />
            </div>
            <h1 className="text-3xl lg:text-5xl font-bold">Tu carrito está vacío</h1>
            <p className="text-lg text-muted-foreground">
              Explora nuestros planes y encuentra el que mejor se adapte a tus necesidades
            </p>
            <Button size="lg" className="mt-4">
              Ver Planes
            </Button>
          </Card>
        </div>
      </div>
    </div>
  )
}
